module.exports = __webpack_public_path__ + "img/4.51dc829.jpg";